/**
 * API Configuration for Web App
 */

import { createApiClient, ApiClient } from '@raffle/api-client';

const DEFAULT_REMOTE_API_URL = 'https://naijavault-api-production.newnichez.workers.dev';

function normalizeBaseUrl(value: string): string {
  return value.trim().replace(/\/+$/, '');
}

// API base URL - use environment variable or default to deployed API
const API_BASE_URL = normalizeBaseUrl(import.meta.env.VITE_API_URL || DEFAULT_REMOTE_API_URL);

// Token management
let accessToken: string | null = null;
let refreshToken: string | null = null;

export function getAccessToken(): string | null {
  if (!accessToken) {
    accessToken = localStorage.getItem('access_token');
  }
  return accessToken;
}

export function getRefreshToken(): string | null {
  if (!refreshToken) {
    refreshToken = localStorage.getItem('refresh_token');
  }
  return refreshToken;
}

export function setTokens(tokens: { accessToken: string; refreshToken: string }) {
  accessToken = tokens.accessToken;
  refreshToken = tokens.refreshToken;
  localStorage.setItem('access_token', tokens.accessToken);
  localStorage.setItem('refresh_token', tokens.refreshToken);
}

export function clearTokens() {
  accessToken = null;
  refreshToken = null;
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
}

// Create API client instance
export const api: ApiClient = createApiClient({
  baseUrl: API_BASE_URL,
  getAccessToken,
  onTokenExpired: async () => {
    // Try to refresh the token
    const refresh = getRefreshToken();
    if (refresh) {
      try {
        const result = await api.auth.refresh(refresh);
        if (result.success && result.data) {
          setTokens({
            accessToken: result.data.tokens.accessToken,
            refreshToken: result.data.tokens.refreshToken,
          });
          return;
        }
      } catch {
        // Refresh failed
      }
    }
    // If refresh fails, clear tokens and redirect to login
    clearTokens();
    window.location.href = '/login';
  },
  onUnauthorized: () => {
    clearTokens();
    window.location.href = '/login';
  },
});

export { API_BASE_URL };
